import { AreaScheduleDTO } from './AreaScheduleDTO'
import { DiaryNoteDTO } from '@services/DTO/DiaryNoteDTO'
import { BookingSlotVelocityLimitOverrideDTO } from './BookingSlotVelocityLimitOverrideDTO'

export class VenueScheduleDTO {

    constructor(
        public diaryNotes: DiaryNoteDTO[],
        public areaSchedules: AreaScheduleDTO[],
        public bookingSlotVelocityLimitOverrides: BookingSlotVelocityLimitOverrideDTO[]
    ) { }
}
